<template>
    <form-select
        :error="error"
        :required="required"
        :value="internalValue"
        @input="handleInput"
        name="salutation"
        label="salutation"
        :options="options"
        :disabled="disabled"></form-select>
</template>
<script>
export default {
    name: 'salutation-select',
    props: {
        return: {
            type: String,
            required: false,
            default: 'value',
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            required: false,
        },
        value: {
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            internalValue: { name: this.uLang('app.mr'), value: 'mr' },
            options: [
                {name: this.uLang('app.mr'), value: 'mr'},
                {name: this.uLang('app.mrs'), value: 'mrs'},
                {name: this.uLang('app.other'), value: 'other'}
            ]
        }
    },

    watch: {
        value: {
            immediate: true,
            handler: function(newVal) {
                if (newVal != null && typeof newVal === 'string') {
                    this.internalValue = this.options.find((option) => { return option[this.return] === newVal })
                    return
                }

                this.internalValue = newVal
            }
        },

        internalValue(value) {
            if(value != null && (typeof value === 'object' || Array.isArray(value))) {
                return this.$emit('input', value[this.return])
            }

            return this.$emit('input', value)
        }
    },

    methods: {
        handleInput(event) {
            this.internalValue = event
        },
    }
}
</script>
